module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAAd0SU1FB94LGwsWA53sPfwAAAAuSURBVDjLY2AYBaOAUsCopKT0H1ng3r17jMh8dHl0QEg9E619MPQtGAWjgHIAADFSCW0Z+2itAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_en_construccion.png
// module id = 61Y7
// module chunks = 0